import React from 'react';
import NativeIdentityButton from './NativeIdentityButton';
const { nativeIdentityPlugin } = require('../utils/nativeIdentity');
import { useEffect, useRef, useState } from 'react';

const clientId = (process.env.REACT_APP_KELIMO_GOOGLE_CLIENT_ID || '').trim();
const { loadGoogleIdentity } = require('../utils/googleIdentityLoader');
const {createGoogleButtonSession}=require('../utils/googleButtonSession');

function WebGoogleIdentityButton({ onCredential, label, personalized=true }) {
  const host = useRef(null);
  const credentialHandler = useRef(onCredential);
  credentialHandler.current = onCredential;
  const [error, setError] = useState('');
  useEffect(() => {
    if (!clientId) return;
    let active = true;
    let observer;
    let session;
    let width = 0;
    loadGoogleIdentity().then(id => {
      if (!active || !host.current) return;
      session=createGoogleButtonSession(id,clientId,credential=>{if(active)credentialHandler.current(credential);});
      const render = () => {
        if (!active || !host.current) return;
        const nextWidth = Math.min(400, Math.floor(host.current.getBoundingClientRect().width));
        if (nextWidth <= 0 || nextWidth === width) return;
        width = nextWidth;
        host.current.replaceChildren();
        id.renderButton(host.current, { theme: 'outline', size: personalized?'large':'medium', shape: 'pill', text: 'continue_with', locale: 'tr', width: nextWidth, click_listener: session.activate, state:session.state });
      };
      render();
      if (typeof ResizeObserver !== 'undefined') {
        observer = new ResizeObserver(render);
        observer.observe(host.current);
      }
    }).catch(cause => { if (active) setError(cause.message); });
    return () => { active = false; session?.dispose(); observer?.disconnect(); if (host.current) host.current.replaceChildren(); };
  }, [personalized]);
  if (!clientId) return null;
  return <div className="flex w-full flex-col items-center gap-2">{label && <span className="google-action-label-r29 text-xs text-slate-600">{label}</span>}<div ref={host} className="google-identity-host google-pill-r28 min-h-[40px] w-full max-w-[400px]" />{error && <p role="alert" className="text-xs text-red-700">{error}</p>}</div>;
}

export default function GoogleIdentityButton(props) {
  if (window.Capacitor?.isNativePlatform?.()) return nativeIdentityPlugin('google') ? <NativeIdentityButton provider="google" onCredential={props.onCredential} label={props.label} /> : <p className="text-xs text-slate-500">Google doğrulaması bu cihazda henüz etkin değil.</p>;
  return <WebGoogleIdentityButton {...props} />;
}
